import { data } from '../../svg/Portal/data';
import { makeIcon } from '../makeIcon';

export const Portal = makeIcon(data, 'portal', 'Portal');

export default Portal;
